import type { Module } from '@/store/root/types';

export const teamContextLinks = {
  overview: [
    {
      alias: 'WX_GENERAL_ADD_ENTRY',
      method: 'add_line',
    },
  ],
  // transferscope 1: only one line is transmitted
  navItem: [
    {
      alias: 'WX_GENERAL_DELETE_ENTRY',
      color: '#b50a00',
      device: '',
      icon: 'trash',
      method: 'callback',
      param: 'command/clear_teammember',
      target: '',
      transferScope: '2',
    },
  ],
};

export const teammembersConfig: Module = {
  general: {
    pageSize: 20,
    alias: 'WX_SEGMENT_TITLE',
    aliasPlural: 'WX_SEGMENT_TITLE',
    titlePattern: '',
    aliasOnCreate: '',
    icon: '',
    color: '',
    colorSecondary: '',
  },
  pageSize: 20,
  lists: {
    teamMembersListGeneral: {
      default: {
        device: '',
        columns: [
          {
            fieldBind: 'FULLNAME',
            fieldType: 'WXAutosuggest',
            maxlength: 80,
            alias: 'WX_COMP_NAME',
            required: true,
            invisible: false,
            readOnly: false,
            position: 6,
            align: 'left',
            iconKind: '',
            color: '',
          },
          {
            fieldBind: 'DEPARTMENT',
            fieldType: 'WXInput',
            maxlength: 40,
            alias: 'WX_CP_DEPARTMENT',
            position: 16,
            align: 'left',
            required: false,
            invisible: false,
            readOnly: true,
            tValue: '__ITML__WAE_TSABT',
            iconKind: '',
            color: '',
          },
          {
            fieldBind: 'EMAIL',
            fieldType: 'WXInput',
            maxlength: 241,
            alias: 'WX_CP_MAIL',
            position: 10,
            align: 'left',
            required: false,
            invisible: false,
            readOnly: true,
            iconKind: 'mail',
            color: '',
            uriScheme: 'mailto',
          },
          {
            fieldBind: 'TEL_NUMBER',
            fieldType: 'WXInput',
            maxlength: 30,
            alias: 'WX_CP_PHONE',
            position: 12,
            align: 'left',
            required: false,
            invisible: false,
            readOnly: true,
            iconKind: 'phone',
            color: '',
            uriScheme: 'callto',
          },
          {
            fieldBind: 'FUNCTION',
            fieldType: 'WXInput',
            maxlength: 40,
            alias: 'WX_CP_FUNCTION',
            position: 20,
            align: 'left',
            required: false,
            invisible: false,
            readOnly: true,
            tValue: '__ITML__WAE_TPFKT',
            iconKind: '',
            color: '',
          },
        ],
        variants: [],
      },
    },
    teammembersExpSearch: {
      default: {
        columns: [],
        device: '',
        variants: [],
      },
    },
  },
  areaPattern: [],
  autoSuggest: [
    {
      FIELDNAME: 'FULLNAME',
      RECORD: '',
      NUM_CHARS: 3,
      INPUT_MAP: '',
      OUTPUT_MAP: 'NAME_TEXT BNAME',
      output: [
        {
          field: 'NAME_TEXT',
          text: 'Vollst.Name',
        },
        {
          field: 'BNAME',
          text: 'Benutzer',
        },
      ],
    },
  ],
};
